import React, { useEffect, useRef, useCallback, memo } from 'react';
import classNames from 'classnames';

import uniqueId from '../../utils/uniqueId';
import FieldError from './FieldError';

const PhoneInputComponent = ({
  autoFocus = false,
  error,
  onErrorClose,
  changed = false,
  value,
  onChange,
  className,
  name,
  onBlur,
  maxLength = 30,
  disabled,
  placeholder,
}) => {
  const id = useRef(uniqueId());

  const handleFocus = useCallback(() => {
    if (onErrorClose) {
      onErrorClose();
    }
  }, [onErrorClose]);

  useEffect(() => {
    if (autoFocus) {
      setTimeout(() => {
        try {
          const element = document.getElementById(id.current);

          if (element) {
            element.focus();
          }
        } catch (focusError) {
          console.warn(focusError);
        }
      }, 0);
    }
  }, [autoFocus]);

  const divClass = classNames('clearfix', className, { 'has-error': error });
  const inputClass = classNames('form-control input-md', { changed });

  return (
    <div className={divClass}>
      <label htmlFor={id.current}>Phone</label>
      <span className="control-wrap">
        <input
          autoComplete="off"
          className={inputClass}
          disabled={disabled}
          id={id.current}
          maxLength={maxLength}
          name={name}
          onBlur={onBlur}
          onChange={onChange}
          onFocus={handleFocus}
          placeholder={placeholder}
          value={value}
        />
      </span>
      <FieldError message={error} />
    </div>
  );
};

export const PhoneInput = memo(PhoneInputComponent);
